import React, { useEffect } from "react";
import Header from "../../layout/Header";
import Sidebar from "../../layout/Sidebar";
import $ from "jquery";

const MyStudiesDashboard = () => {
  useEffect(() => {
    if ($(window).width() < 600) {
      $("#sidebar").removeClass("show-sidebar").addClass("hide-sidebar");
    } else {
      $("#sidebar").removeClass("hide-sidebar").addClass("show-sidebar");
    }
  }, []);

  return (
    <div className="mystudies-dashboard-page">
      <Header />
      <div className="row">
        <Sidebar />
        <div
          className="col-lg-10 main_content_right_side"
          style={{
            minHeight: "100vh",
            paddingLeft: "32px",
            paddingRight: "30px",
            marginLeft: "auto",
            backgroundColor: "#F5F5F5",
          }}
        >
          <div className="main-section" style={{ marginTop: 105 }}>
            <div className="row">
              <div className="col-12">
                <h3
                  style={{
                    fontSize: "24px",
                    color: "#1A4F95",
                    fontWeight: "600",
                  }}
                  className="mb-3"
                >
                  My Studies Dashboard
                </h3>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MyStudiesDashboard;
